module.exports = __webpack_public_path__ + "assets/vendors/FlexSlider-bg_direction_nav.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/FlexSlider/images/bg_direction_nav.png
// module id = 26kS
// module chunks = 0